import { Component, ViewChild, TemplateRef, Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { UserService } from '../../../services/user.service';
import { FormService } from 'src/app/services/form.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Store } from '@ngrx/store';
import { NgxSpinnerService } from 'ngx-spinner';
import * as FormActions from '../../../reducers/actions/forms.actions';
import { Form, FormControl, Validators } from '@angular/forms';
import { PerfilComponent } from '../../perfil/perfil.component';
import { Observable, BehaviorSubject } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { Propiedades } from 'src/app/models/propiedades.model';
import { Http } from '@angular/http';

import { GLOBAL } from 'src/app/services/global';

declare const swal: any;

interface AppState {
  form: Form;
}


@Component({
    selector: "page-busqueda_dir",
    templateUrl: "busqueda_dir.component.html",
    styleUrls: ["./busqueda_dir.component.css"],
    providers: [UserService, FormService]
})

export class Busqueda_dirComponent {

    public errorMessage = ''
    displayedColumns: string[] = ['Propiedad_Direccion::PDI_Calle_Nombre', 'Propiedad_Direccion::PDI_Num_Calle', 'Propiedad_Direccion::PDI_Num_Ex', 'Propiedad_Direccion::PDI_Direc_Complemento_Tipo', 'Propiedad_Direccion::PDI_Direc_Complemento_Num', 'Propiedad_Direccion::PDI_Anexo', 'Propiedad_Direccion::PDI_Anexo_Num']
    public certificado_info
    public arreglo 
    buscando = false
    public rol = new FormControl('', [Validators.required]);
    public calle = new FormControl('', [Validators.required]);    
    public nroCalle = new FormControl('', [Validators.required]);
    public fecha_ingreso = new FormControl('', [Validators.required]);
    public rol_busqueda
    public inforol
    public address
    public geolocationRes
    public comunaMapa = GLOBAL.comunaMapa;
    marcadores: Marcador[] = [];
    
    public Propiedades: Propiedades;
    public direcciones: MatTableDataSource<Propiedades>;
    documentos: MatTableDataSource<any>;
    dataCips: MatTableDataSource<any>;
  
    identity
    token

    
    //coordenadas del centro de Colina //la florida
    public lat:number = -33.202472    //-33.53071445
    public lng:number = -70.6749147   //-70.54402715
    public nombreMarker:string = ''
  
    constructor(private _snackBar: MatSnackBar, private dialog: MatDialog, private store: Store<AppState>, private _user: UserService, private spinner: NgxSpinnerService, private _cd: ChangeDetectorRef, public http:  Http) {
        
    }





    buscar(rol?, calle?, num?) {

        var dirs = []
        var docs = []
        var cips = []

        this.spinner.show()
        if (this.rol.valid) {
            this._user.buscar_direc_all(this.rol.value).subscribe(response => {
                //console.log(response)
                if (response.status == "error") {
                    this.spinner.hide()
                    console.log(response.message)
                    swal({
                        type: 'warning',
                        title: 'Atención!',
                        text: response.message,
                        confirmButtonColor: '#3F51B5',
                        confirmButtonText: 'Aceptar',
                        timer: 3500
                    }).then(() => {
                    }, (dismiss) => {
                        if (dismiss === 'timer') {
                        }
                    });
                } else {
                    this.rol_busqueda = this.rol.value

                    if (response.res.portalData.Propiedad_Direccion.length > 0) {
                        for (let x = 0; x < response.res.portalData.Propiedad_Direccion.length; x++) {
                            const element = response.res.portalData.Propiedad_Direccion[x];
                            dirs.push(element)
                        }
                        
                        this.direcciones = new MatTableDataSource(dirs)
                    } 
                    
                
                    else {
                        var defaultObj = [{
                            'Propiedad_Direccion::PDI_Calle_Nombre': "",
                            'Propiedad_Direccion::PDI_Direc_Anexo_Num': "",
                            'PPropiedad_Direccion::PDI_Direc_Anexo_Tipo': "",
                            'Propiedad_Direccion::PDI_Direc_Complemento_Num': "",
                            'Propiedad_Direccion::PDI_Direc_Complemento_Tipo': "",
                            'Propiedad_Direccion::PDI_Num_Calle': "",
                            'Propiedad_Direccion::PDI_Num_Ex':"",
                            'modId':"",
                            'recordId':""
                        }]
                        dirs.push(defaultObj)
                        this.direcciones = new MatTableDataSource(dirs)
                    }   
                    
                    this._cd.detectChanges(); 
                    this.inforol = response

                    
                    if(this.marcadores.length>0){
                        this.marcadores = [];
                    }
                    this.inforol.res.portalData.Propiedad_Direccion.forEach((element, index) => {
                        this.address = this.inforol.res.portalData.Propiedad_Direccion[index]['Propiedad_Direccion::PDI_Calle_Nombre'] + '%20' + this.inforol.res.portalData.Propiedad_Direccion[index]['Propiedad_Direccion::PDI_Num_Calle']
                        this.address.replace(/ /g, "%20")
                        this.address.replace(" ", "%20")
                        this.getGeolocation(this.address)   
                        //console.log(element)
                    });
                    
                                 

                    console.log(this.inforol)
                    
                    this.buscando = true                
                    this.spinner.hide()
                }

            }, error => {
                console.log(error)
                this.spinner.hide()
                swal({
                    type: 'warning',
                    title: 'Atención!',
                    text: 'Error Inesperado, Intente más tarde',
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                }).then(() => {
                }, (dismiss) => {
                    if (dismiss === 'timer') {
                    }
                })
                this.spinner.hide()
            })
        } else if (this.calle.valid && this.nroCalle.valid) {
            this._user.traerInfo_propiedad_direccion(this.calle.value, this.nroCalle.value).subscribe(response => {

                if (response.status == "error") {
                    this.spinner.hide()
                    swal({
                        type: 'warning',
                        title: 'Atención!',
                        text: response.message,
                        confirmButtonColor: '#3F51B5',
                        confirmButtonText: 'Aceptar',
                        timer: 3500
                    }).then(() => {
                    }, (dismiss) => {
                        if (dismiss === 'timer') {
                        }
                    });
                    this.calle.setValue("")
                    this.nroCalle.setValue("")
                } else {

                    console.log("busqueda por calle y nro: ", response)
                    this.rol_busqueda = response.rol
                    this._user.buscar_direc_all(response.rol).subscribe(response => {

                        if (response.res.portalData.Propiedad_Direccion.length > 0) {
                            for (let x = 0; x < response.res.portalData.Propiedad_Direccion.length; x++) {
                                const element = response.res.portalData.Propiedad_Direccion[x];
                                dirs.push(element)
                            }
                            
                            this.direcciones = new MatTableDataSource(dirs)
                        } 
                        
                        
                        else {
                            var defaultObj = [{
                                'Propiedad_Direccion::PDI_Calle_Nombre': "",
                                'Propiedad_Direccion::PDI_Direc_Anexo_Num': "",
                                'PPropiedad_Direccion::PDI_Direc_Anexo_Tipo': "",
                                'Propiedad_Direccion::PDI_Direc_Complemento_Num': "",
                                'Propiedad_Direccion::PDI_Direc_Complemento_Tipo': "",
                                'Propiedad_Direccion::PDI_Num_Calle': "",
                                'Propiedad_Direccion::PDI_Num_Ex':"",
                                'modId':"",
                                'recordId':""
                            }]
                            dirs.push(defaultObj)
                            this.direcciones = new MatTableDataSource(dirs)
                        }   

                        

                        this._cd.detectChanges();
                        this.inforol = response
                        this.buscando = true

                        if(this.marcadores.length>0){
                            this.marcadores = [];
                        }
                        this.inforol.res.portalData.Propiedad_Direccion.forEach((element, index) => {
                            this.address = this.inforol.res.portalData.Propiedad_Direccion[index]['Propiedad_Direccion::PDI_Calle_Nombre'] + '%20' + this.inforol.res.portalData.Propiedad_Direccion[index]['Propiedad_Direccion::PDI_Num_Calle']
                            this.address.replace(/ /g, "%20")
                            this.address.replace(" ", "%20")
                            this.getGeolocation(this.address)   
                            //console.log(element)
                        });

                        this.spinner.hide()
                        //console.log(response.res.portalDat.length)
                    }, error => {
                        this.spinner.hide()
                        console.log(error)
                    })
                }


            }, error => {
                this.spinner.hide()
                console.log(error)
                this.errorMessage = JSON.parse(error._body)
                swal({
                    type: 'warning',
                    title: 'Atención!',
                    text: 'Error Inesperado, Intente más tarde',
                    confirmButtonColor: '#3F51B5',
                    confirmButtonText: 'Aceptar',
                    timer: 3500
                }).then(() => {
                }, (dismiss) => {
                    if (dismiss === 'timer') {
                    }
                })
            })
        }

    }

    centerChange(event){
        //console.log(event);
    }
    ChangeMap(event){
        //console.log(event);
    }

    getGeolocation(address) {
        //console.log("https://nominatim.openstreetmap.org/search.php?q="+address+"%20"+this.comunaMapa+"%20santiago&polygon_geojson=1&format=jsonv2")
        let dataLatLng

        //crear servicio nomatim 
        
        //console.log("https://nominatim.openstreetmap.org/search.php?q="+address+"%20la%20florida%20santiago&polygon_geojson=1&format=jsonv2")
        //let geocoder = "https://nominatim.openstreetmap.org/search.php?q="+address+"%20la%20florida%20santiago&polygon_geojson=1&format=jsonv2"
        dataLatLng = this.http.get("https://nominatim.openstreetmap.org/search.php?q="+address+"%20"+this.comunaMapa+"%20santiago&polygon_geojson=1&format=jsonv2").subscribe( 
            (datos:any) => {
                //asdasd=JSON.stringify(datos);
                //dataLatLng=eval(datos);//JSON.stringify(datos);

                try {
                    //console.log("datos de xxxxxx : ",JSON.parse(datos))
                    console.log("datos de respuestas desde nominatim: ",JSON.parse(datos['_body']))
                    dataLatLng=JSON.parse(datos['_body'])
                    
                    this.lat=parseFloat(dataLatLng[0]['lat'])
                    this.lng=parseFloat(dataLatLng[0]['lon'])                    

                    //console.log(this.lat + " " + this.lng)
                    this.nombreMarker = address.replace("%20", " ")

                    var nuevoMarcador = new Marcador(this.lat, this.lng, this.nombreMarker)
                    this.marcadores.push(nuevoMarcador);

                } catch (error) {
                    console.log(error, datos)
                }

            }
        )

        

        
    }
    /*
    createMap(location) {

        console.log(location)
        this.lat = 40.730610;
        this.lng = -73.935242

        console.log(this.coordinates)

        setTimeout(() => {

            console.log(this.coordinates)
            this.mapOptions = google.maps.MapOptions = {
                center: location,
                zoom: 18,
            };
            this.mapInitializer();
            this.marker = new google.maps.Marker({
                position: location,
                map: this.map,
            });

        }, 3000);
    } */

    logout() {
        this.store.dispatch(new FormActions.FormUpdate('0', ''))
        sessionStorage.removeItem("identity-domCloud");
        sessionStorage.removeItem("token-domCloud");
        this._snackBar.open("Se ha cerrado sesión", "Cerrar", {
          duration: 3000,
        });
    
    
    }
    
    openPerfil() {
        this.dialog.open(PerfilComponent)
    }
    
    volver() {
        this.buscando = false
        this.rol.setValue("")
        this.calle.setValue("")
        this.nroCalle.setValue("")
        this.fecha_ingreso.setValue("")   
    }

}

export class Marcador {
    public lat: number;
    public lng: number;
    public titulo = 'Sin titulo';

    constructor(lat: number, lng: number, titulo:string){
        this.lat=lat;
        this.lng=lng;
        this.titulo=titulo
    }
}
